import { PropsWithChildren, createContext,useState } from "react";
import { LookupItemType } from "../common/types";
import { RoleInfo } from "../common/models/roleInfo";


//  context for Local Government list

type AppContextType = {
  localGovsList: LookupItemType[];
  setLocalGovsList: (localGovsList: LookupItemType[]) => void;

  userAdminByList: string[];
  setUserAdminByList: (userAdminByList: string[]) => void;

  allRolesList: RoleInfo[];
  setAllRolesList: (allRolesList: RoleInfo[]) => void;

};

export const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppContextProvider = ({ children }: PropsWithChildren<{}>) => {
  const [localGovsList,setLocalGovsList]      = useState<AppContextType["localGovsList"]>([]);
  const [userAdminByList,setUserAdminByList]  = useState<AppContextType["userAdminByList"]>(["Calgary","Edmonton","Edson","Fort McMurray","Grande Prairie","High Level","Lac La Biche","Peace River","Rocky Mtn House","Slave Lake","Whitecourt"]);
  const [allRolesList,setAllRolesList]      = useState<AppContextType["allRolesList"]>([]);
  
  return (
    <AppContext.Provider value={{ localGovsList, setLocalGovsList,userAdminByList,setUserAdminByList,allRolesList,setAllRolesList}}>
      {children}
    </AppContext.Provider>
  );
};